import accountRoutes from 'router/routes/accounts/accounts';
import administrationRoutes from 'router/routes/administration';
import userRoutes from 'router/routes/user';
import dashboardRoutes from 'router/routes/dashboard';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import projectRoutes from 'router/routes/projects/projects';
import aoriRoutes from 'router/routes/aori';


const routes = [
  {
    path: '/',
    name: 'home',
    redirect: {name: 'accounts'}
  },
  {
    path: '/logout',
    name: 'logout',
    component: wrapLegacyRoute('commonController', 'logout')
  },
  {
    path: '/deimpersonate',
    name: 'deimpersonate',
    component: wrapLegacyRoute('commonController', 'deimpersonate')
  },
  ...administrationRoutes,
  ...userRoutes,
  ...dashboardRoutes,

  ...projectRoutes,
  ...accountRoutes,

  ...aoriRoutes
];

export default routes;
